import { useEffect, useRef } from 'react';

export function useObjectUrls() {
    const mapRef = useRef<Map<File, string> | null>(null);
    useEffect(() => {
        const map = new Map();
        mapRef.current = map;
        return () => {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            for (const [file, url] of map) {
                URL.revokeObjectURL(url);
            }
            mapRef.current = null;
        };
    }, []);

    return function getObjectUrl(file: File) {
        const map = mapRef.current;
        if (!map) {
            throw Error('Cannot getObjectUrl while unmounted');
        }
        if (!map.has(file)) {
            const url = URL.createObjectURL(file);
            map.set(file, url);
        }
        const url = map.get(file);
        if (!url) {
            throw Error('Object url not found');
        }
        return url;
    };
}

export const getHumanReadableFileSize = (number: number) => {
    if (number < 1e3) {
        return `${number} bytes`;
    } else if (number >= 1e3 && number < 1e6) {
        return `${(number / 1e3).toFixed(1)} KB`;
    } else {
        return `${(number / 1e6).toFixed(1)} MB`;
    }
};

export const deriveFileNameFromUrl = (url: string): string => {
    // strips query/hash, keeps last path segment, removes last extension (.jpg/.jpeg/.png/.webp/etc)
    if (!url) return url;
    const clean = url.split('#')[0].split('?')[0];
    const last = clean.substring(clean.lastIndexOf('/') + 1);
    return last.replace(/\.[^.]+$/, '');
};
